import { render, staticRenderFns } from "./uploadTF.vue?vue&type=template&id=e1c1597e&scoped=true&"
import script from "./uploadTF.vue?vue&type=script&lang=js&"
export * from "./uploadTF.vue?vue&type=script&lang=js&"
import style0 from "./uploadTF.vue?vue&type=style&index=0&id=e1c1597e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c1597e",
  null
  
)

export default component.exports